import * as React from "react"
import { graphql } from "gatsby"
import { Layout } from "../components/layout"
import { ProductListing } from "../components/product-listing"
import {
  container,
  intro,
  callOut,
  callToAction,
  deployButton,
} from "./index.module.css"
import "@fontsource/benne"
import { HeroHomePageSection, IngredientLibraryHomePageSection, InstagramFeed, TestimonialsHomePageSection } from "../components/homepageComponents"
import OurStorySection from "../components/home-page/our-story-section";
import { Seo } from "../components/seo"
import HomePageHeaderSection from "../components/home-page/header-section"
import MobileHomePageHeaderSection from "../components/home-page/mobile-header-section"

export const query = graphql`
  query {
    shopifyCollection(handle: { eq: "frontpage" }) {
      products {
        ...ProductCard
      }
    }
  }
`
function Hero(props) {
  return (
    <div className={container}>
      <h1 className={intro} style={{ fontFamily: 'Benne' }}>Better Days Are Here</h1>
    </div>
  )
}

export default function IndexPage({ data }) {
  return (
    <Layout>
      <Seo title={'Better Days Skin Co.'} />
      {/* <Hero /> */}
      <HomePageHeaderSection />
      <MobileHomePageHeaderSection />
      {/* <HeroHomePageSection /> */}
      <TestimonialsHomePageSection />
      <OurStorySection />
      <IngredientLibraryHomePageSection showButton={true} />
      <InstagramFeed />
      {/* <ProductListing products={data?.shopifyCollection?.products} /> */}
    </Layout>
  )
}
